// AUTO-GENERATED — DO NOT EDIT.
// Source: YAML frontmatter in src/content/blog/posts/*.mdx
// Regenerate: npm run build:shared

export const BLOG_ROUTE_CATALOG: readonly Readonly<{
  routePath: `/blog/${string}`;
  publishDate: string;
  updatedDate: string;
}>[] = [
  {
    "routePath": "/blog/direct-school-admission-secondary-guide",
    "publishDate": "2026-04-20",
    "updatedDate": "2026-04-20"
  },
  {
    "routePath": "/blog/exercise-and-maths-performance",
    "publishDate": "2025-06-14",
    "updatedDate": "2025-06-14"
  },
  {
    "routePath": "/blog/full-subject-based-banding-explained",
    "publishDate": "2026-06-09",
    "updatedDate": "2026-06-09"
  },
  {
    "routePath": "/blog/fully-online-vs-hybrid-tuition",
    "publishDate": "2025-09-08",
    "updatedDate": "2025-09-08"
  },
  {
    "routePath": "/blog/how-online-math-tuition-actually-works",
    "publishDate": "2025-11-01",
    "updatedDate": "2025-11-01"
  },
  {
    "routePath": "/blog/how-psle-al-scoring-and-secondary-posting-work",
    "publishDate": "2026-05-20",
    "updatedDate": "2026-05-20"
  },
  {
    "routePath": "/blog/how-to-choose-o-level-math-tuition-without-wasting-money",
    "publishDate": "2025-12-31",
    "updatedDate": "2025-12-31"
  },
  {
    "routePath": "/blog/how-to-tell-if-your-child-is-paying-attention-in-an-online-class",
    "publishDate": "2025-08-13",
    "updatedDate": "2025-08-13"
  },
  {
    "routePath": "/blog/integrated-programme-explained",
    "publishDate": "2026-05-08",
    "updatedDate": "2026-09-05"
  },
  {
    "routePath": "/blog/ip-schools-in-singapore",
    "publishDate": "2026-08-13",
    "updatedDate": "2026-09-05"
  },
  {
    "routePath": "/blog/is-a-math-required-for-polytechnic",
    "publishDate": "2026-08-13",
    "updatedDate": "2026-09-05"
  },
  {
    "routePath": "/blog/is-online-math-tuition-effective-for-psle",
    "publishDate": "2026-02-09",
    "updatedDate": "2026-02-09"
  },
  {
    "routePath": "/blog/math-skills-that-matter-after-school",
    "publishDate": "2025-05-05",
    "updatedDate": "2025-05-05"
  },
  {
    "routePath": "/blog/math-tuition-for-students-with-high-anxiety",
    "publishDate": "2025-12-11",
    "updatedDate": "2025-12-11"
  },
  {
    "routePath": "/blog/normal-academic-g2-pathways",
    "publishDate": "2025-07-04",
    "updatedDate": "2025-07-04"
  },
  {
    "routePath": "/blog/normal-technical-g1-pathways",
    "publishDate": "2026-06-29",
    "updatedDate": "2026-06-29"
  },
  {
    "routePath": "/blog/online-math-tuition-singapore-busy-parent-guide",
    "publishDate": "2026-03-21",
    "updatedDate": "2026-03-21"
  },
  {
    "routePath": "/blog/online-tuition-commute-time",
    "publishDate": "2025-06-18",
    "updatedDate": "2025-06-18"
  },
  {
    "routePath": "/blog/online-tuition-reduce-infection-spread",
    "publishDate": "2025-08-20",
    "updatedDate": "2025-08-20"
  },
  {
    "routePath": "/blog/polytechnic-vs-junior-college-after-o-levels",
    "publishDate": "2026-05-30",
    "updatedDate": "2026-05-30"
  },
  {
    "routePath": "/blog/primary-math-word-problem-mistakes",
    "publishDate": "2025-11-21",
    "updatedDate": "2025-11-21"
  },
  {
    "routePath": "/blog/should-my-child-take-a-math",
    "publishDate": "2025-09-22",
    "updatedDate": "2025-09-22"
  },
  {
    "routePath": "/blog/singapore-haze-online-tuition",
    "publishDate": "2025-10-05",
    "updatedDate": "2025-10-05"
  },
  {
    "routePath": "/blog/sleep-and-math-performance",
    "publishDate": "2025-07-24",
    "updatedDate": "2025-07-24"
  },
  {
    "routePath": "/blog/webcams-on-small-group-online-tuition",
    "publishDate": "2025-07-30",
    "updatedDate": "2025-07-30"
  },
  {
    "routePath": "/blog/weekly-math-revision-routine",
    "publishDate": "2025-10-12",
    "updatedDate": "2025-10-12"
  },
  {
    "routePath": "/blog/what-good-o-level-math-revision-looks-like",
    "publishDate": "2026-04-10",
    "updatedDate": "2026-04-10"
  },
  {
    "routePath": "/blog/what-good-psle-math-revision-looks-like",
    "publishDate": "2026-04-30",
    "updatedDate": "2026-04-30"
  },
  {
    "routePath": "/blog/what-the-data-says-about-tuition-in-singapore",
    "publishDate": "2025-05-25",
    "updatedDate": "2025-05-28"
  },
  {
    "routePath": "/blog/what-the-research-says-about-math-anxiety",
    "publishDate": "2026-07-19",
    "updatedDate": "2026-07-19"
  },
  {
    "routePath": "/blog/when-to-start-o-level-math-preparation",
    "publishDate": "2026-01-20",
    "updatedDate": "2026-01-20"
  },
  {
    "routePath": "/blog/why-struggling-with-math-beats-getting-the-right-answer",
    "publishDate": "2025-09-02",
    "updatedDate": "2025-09-02"
  },
  {
    "routePath": "/blog/why-your-child-keeps-losing-marks-in-math",
    "publishDate": "2026-03-01",
    "updatedDate": "2026-03-01"
  }
];
